import React, { Component } from "react";
import queryString from "query-string";
import { Helmet } from "react-helmet";
import store from "../store";
import Breadcrumbs from "../components/Breadcrumbs/Breadcrumbs";


class SearchResults extends Component {

    constructor(props) {
        super(props);
        this.state = {
            searchData: { searchData: [] },
            matchedItems: [],
            noResults: {
                message: "Your search for {searchValue} did not return any results. Give it another try or check out these resources:",
                links: [
                    {
                        url: "https://www.swacargo.com/swacargo_com_ui/learn/how-to-ship",
                        tabName: null,
                        selectedId: null,
                        title: "How to Ship"
                    },
                    {
                        url: "https://www.swacargo.com/swacargo_com_ui/learn/specialty-shipments",
                        tabName: null,
                        selectedId: null,
                        title: "Specialty Shipments"
                    },
                    {
                        url: "https://www.swacargo.com/swacargo_com_ui/learn/faq",
                        tabName: null,
                        selectedId: null,
                        title: "FAQ"
                    },
                    {
                        url: "https://www.swacargo.com/swacargo_com_ui/learn/declared-value",
                        tabName: null,
                        selectedId: null,
                        title: "Declared Value"
                    },
                    {
                        url: "https://www.southwest.com/rapid-rewards/cargo/#apply",
                        tabName: null,
                        selectedId: null,
                        title: "Rapid Rewards® Cargo"
                    }
                ]
            }
        };
    }

    levenshteinDistance = (s, t) => {
        if (!s.length) return t.length;
        if (!t.length) return s.length;
        const arr = [];
        for (let i = 0; i <= t.length; i++) {
            arr[i] = [i];
            for (let j = 1; j <= s.length; j++) {
                arr[i][j] = i === 0 ? j : Math.min(arr[i - 1][j] + 1, arr[i][j - 1] + 1, arr[i - 1][j - 1] + (s[j - 1] === t[i - 1] ? 0 : 1));
            }
        }
        return arr[t.length][s.length];
    };

    stringMatch = (keyword, searchParam) => {
        const lowKeyword = keyword.toLowerCase();
        const lowSearchParam = searchParam.toLowerCase();
        const levDist = this.levenshteinDistance(lowKeyword, lowSearchParam);
        const keyLen = keyword.length;
        return (keyLen - levDist) / keyLen;
    };

    findArrayMatch(searchArray, value) {
        return searchArray.find(obj => obj.title === value);
    }

    sortByFrequencyAndRemoveDuplicates(array) {
        let frequency = {},
                value;

        for (let i = 0; i < array.length; i++) {
            value = array[i];
            if (value.title in frequency) {
                frequency[value.title]++;
            } else {
                frequency[value.title] = 1;
            }
        }

        let uniques = [];
        for (value in frequency) {
            uniques.push(this.findArrayMatch(array, value));
        }

        function compareFrequency(a, b) {
            return frequency[b.title] - frequency[a.title];
        }

        return uniques.sort(compareFrequency);
    }



    async componentDidMount() {
        try {
            const headers = new Headers({
                "cache-control": "max-age=172800"
            });
            const response = await fetch("./content/search/searchTerms.json", {
                headers: headers
            });

            if (!response.ok) {
                throw new Error(`Failed to fetch data: ${response.statusText}`);
            }

            const searchData = await response.json();
            console.log(searchData)
            this.setState({ searchData }, () => {
                this.handleSearch(); // Ensure `handleSearch` runs after `searchData` is updated
            });
        } catch (error) {
            console.error("Error fetching data:", error);
        }

    }
    componentDidUpdate(prevProps, prevState) {
        if (this.props.location.search !== prevProps.location.search) {
            this.handleSearch();
        }
    }

    handleSearch = () => {
        const querystringParams = queryString.parse(this.props.location.search);
        const trackingIdParam = querystringParams.search;
        let matchedArray = [];

        if (trackingIdParam) {
            this.state.searchData.searchData.forEach(item => {
                if (item.keywords) {
                    item.keywords.forEach(keyword => {
                        if (this.stringMatch(keyword, trackingIdParam) >= 0.75) {
                            matchedArray.push(item);
                        }
                    });
                }
            });

            this.setState({ matchedItems: this.sortByFrequencyAndRemoveDuplicates(matchedArray) });
        }
    };

    noResultString() {
        const queryParameters = new URLSearchParams(window.location.search);
        const searchValue = queryParameters.get("search");
        let message = this.state.noResults.message;
        message = message.replace("{searchValue}", searchValue);
        return message;
    }

    render() {
        return (
                <div className="wrapper">
                    <Helmet>
                        {store.getState().sitemapData.sitemap
                                ? store.getState().sitemapData.sitemap.map(row => {
                                    return row.rowTitle === "About"
                                            ? row.sections.map(section => {
                                                return section.title === "News" ? <meta name="description" content={section.content["seo-description"]} /> : null;
                                            })
                                            : null;
                                })
                                : null}
                    </Helmet>
                    <Breadcrumbs />

                    <div className="cards-list__archive-block-container mtm">
                        <div className="wrapper">
                            {this.state.matchedItems.length > 0 ? (
                                    this.state.matchedItems.map((item, index) => (
                                            <div className="sResults" key={index}>
                                                <h1 className="searchTitle">
                                                    {index + 1}.{" "}
                                                    <a href={item.url} target="_blank" rel="noopener noreferrer">
                                                        {item.title}
                                                    </a>
                                                </h1>
                                                <div className="seachDesc"> {item.description}</div>
                                            </div>
                                    ))
                            ) : (
                                    <div>
                                        <p>{"Uh oh, we couldn't find any results."}</p>
                                        <br />
                                        <p>{this.noResultString()}</p>
                                        {this.state.noResults.links.map((item, index) => (
                                                <p key={index}>
                                                    <a href={item.url} target="_blank" rel="noopener noreferrer">
                                                        {item.title}
                                                    </a>
                                                </p>
                                        ))}
                                    </div>
                            )}
                        </div>
                    </div>
                </div>
        );
    }
}

export default SearchResults;



// WEBPACK FOOTER //
// ./src/pages/SearchResults.js